import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  CreateOffRampBridgeTosLinkMutation,
  CreateOffRampBridgeTosLinkMutationVariables,
} from './__generated__/useCreateOffRampBridgeTosLink.graphql.ts';

const CREATE_OFF_RAMP_BRIDGE_TOS_LINK_MUTATION = gql`
  mutation CreateOffRampBridgeTosLinkMutation(
    $input: createOffRampBridgeTosLinkInput!
  ) {
    createOffRampBridgeTosLink(input: $input) {
      tosUrl
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  CreateOffRampBridgeTosLinkMutation,
  CreateOffRampBridgeTosLinkMutationVariables
>;

export const useCreateOffRampBridgeTosLink = () => {
  const [mutate] = useMutation(CREATE_OFF_RAMP_BRIDGE_TOS_LINK_MUTATION, {
    showErrorsInForm: true,
  });

  return async (returnUrl: string) =>
    mutate({ variables: { input: { returnUrl } } });
};
